/**
 * Created by andreaskarantzas on 09.04.21.
 */
import { makeAutoObservable } from 'mobx';

export type BreathingTechniqueStepTypes = 'inhale' | 'hold' | 'exhale';

export type BreathingTechniqueStep = {
  type: BreathingTechniqueStepTypes;
  /** the duration is in seconds **/
  duration: number;
};

export function createBreathingTechniqueStep(json?: Partial<BreathingTechniqueStep>): BreathingTechniqueStep {
  return makeAutoObservable({
    type: json?.type ?? 'inhale',
    duration: json?.duration || 2,
  });
}
